class FPRecentlyViewed extends HTMLElement {
  static storageKey = 'fp-recently-viewed-products-v2';

  connectedCallback() {
    this.hidden = true;
    try {
      const current = JSON.parse(this.querySelector('[data-fp-current-product]')?.textContent || '{}');
      if (!current.id || !current.url) return;

      const stored = this.readProducts();
      const maximum = Math.max(4, Number.parseInt(this.dataset.maxProducts || '6', 10));
      const previous = stored.filter((item) => String(item.id) !== String(current.id)).slice(0, maximum);
      this.renderProducts(previous);
      this.writeProducts([current, ...previous].slice(0, maximum + 1));
    } catch (error) {
      console.warn('[Fifth & Piedmont] Recently viewed history unavailable.', error);
    }
  }

  readProducts() {
    try {
      const parsed = JSON.parse(localStorage.getItem(FPRecentlyViewed.storageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.id && item.url) : [];
    } catch (_error) {
      localStorage.removeItem(FPRecentlyViewed.storageKey);
      return [];
    }
  }

  writeProducts(products) {
    localStorage.setItem(FPRecentlyViewed.storageKey, JSON.stringify(products));
  }

  renderProducts(products) {
    const list = this.querySelector('[data-fp-recently-viewed-results]');
    if (!list || products.length === 0) return;

    list.replaceChildren(...products.map((product) => this.productCard(product)));
    this.hidden = false;
  }

  productCard(product) {
    const item = document.createElement('li');
    const link = document.createElement('a');
    const media = document.createElement('div');
    const image = document.createElement('img');
    const copy = document.createElement('div');
    const vendor = document.createElement('p');
    const title = document.createElement('h3');
    const price = document.createElement('p');

    item.className = 'fp-merch-card';
    item.setAttribute('data-fp-product-card', '');
    link.className = 'fp-merch-card__link';
    link.href = product.url;
    media.className = 'fp-merch-card__media';
    // Preserve existing browser history while bringing its reviewed watch brands
    // into the same framing as newly recorded products.
    const category = product.category || (['Corniche', 'Locman', 'Farer'].includes(product.vendor) ? 'watches' : '');
    if (category) media.dataset.fpCardCategory = category;
    media.dataset.fpCardVendor = product.vendor || "";
    image.className = 'fp-merch-card__image';
    if (product.image) {
      image.src = product.image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      media.appendChild(image);
    } else {
      media.classList.add('fp-merch-card__placeholder');
      media.setAttribute('aria-hidden', 'true');
    }
    copy.className = 'fp-merch-card__copy';
    vendor.className = 'fp-merch-card__vendor';
    vendor.textContent = product.vendor || '';
    title.className = 'fp-merch-card__title';
    title.textContent = product.title || '';
    price.className = 'fp-merch-card__price';
    price.textContent = product.price || '';

    copy.append(vendor, title, price);
    link.append(media, copy);
    item.appendChild(link);
    return item;
  }
}

if (!customElements.get('fp-recently-viewed')) {
  customElements.define('fp-recently-viewed', FPRecentlyViewed);
}
